<template>
  <div class="page">
    <div class="router">
      <div @click="$router.go(-1)" class="back">
        <a-icon type="left"></a-icon>
        <div class="name">返回</div>
      </div>
      <div class="extra">
        <a-space v-if="id">
          <!-- <a-button size="small" @click="handleShowDrag" shape="round"
            >AI分析助手</a-button
          > -->
          <div style="font-size: 12px;">{{ saveTime }}</div>
          <a-button v-if="!editState" size="small" @click="handlePush('draft')" shape="round"
            >暂存</a-button
          >
          <a-button
            type="primary"
            shape="round"
            @click="handlePush('official')"
            size="small"
            >立即发布</a-button
          >
        </a-space>
        <a-space v-else>
          <!-- <a-button size="small" type="link"  @click="handleShowDrag" shape="round"
            >AI分析助手</a-button
          > -->
          <div style="font-size: 12px;">{{ saveTime }}</div>
          <a-button size="small" @click="handlePush('draft')" shape="round"
            >暂存</a-button
          >
          <a-button
            type="primary"
            shape="round"
            @click="handlePush('official')"
            size="small"
            >立即发布</a-button
          >
        </a-space>
        <!-- <drag :visible.sync="showDrag" /> -->
      </div>
    </div>

    <div v-if="form.type == 1" class="srcoll">
      <div class="head flex-row">
        <div class="title">{{ id ? "编辑" : "发布" }}观察记录-快速记</div>
        <div v-if="!id" @click="handleShowPlate" class="right">
          <a-button type="link" size="small">
            <a-icon type="book" />更换记录表模板</a-button
          >
        </div>
      </div>

      <section class="section">
        <section
          v-for="(item, index) in record_att"
          :key="index"
          class="z-item"
          style="margin-bottom: 10px;"
        >
          <div class="z-title">
            观察实录<span>*</span
            ><a-button
              style="margin-left: 10px;font-size: 12px;"
              @click="record_att.splice(index, 1)"
              v-show="index != 0"
              size="small"
              ><a-icon
                style="margin-right: -5px;"
                type="delete"
              />移除</a-button
            >
          </div>
          <div class="input">
            <a-textarea
              placeholder="填写记录"
              autoSize
              v-model="item.record_text"
              :rows="4"
              :maxLength="3000"
              style="border: none;min-height: 100px"
            />
            <div class="number">{{ item.record_text.length }}/3000</div>
          </div>

          <div class="upload">
            <a-upload
              :style="{ width: item.fileList.length ? '100%' : '120px' }"
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :fileList="item.fileList"
              :remove="handleRemove"
              :before-upload="beforeUpload"
              :show-upload-list="true"
              @preview="handlePreview"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
              multiple
              @change="
                (info) => {
                  item.fileList = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('@/assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传照片/视频
                </div>
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              :style="{ width: item.fileList2.length ? '100%' : '120px' }"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="true"
              :remove="handleRemove"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="audio/*"
              multiple
              :fileList="item.fileList2"
              @preview="handlePreview"
              @change="
                (info) => {
                  item.fileList2 = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('@/assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传音频
                </div>
              </div>
            </a-upload>
          </div>
          <div class="upload-tip">
            单个图片/视频不能超过500M;上传上限100张图片
          </div>
        </section>
      </section>

      <section class="section">
        <div class="z-title">观察对象 <span>*</span></div>
        <div class="content">
          <a-space style="width: 100%;flex-wrap: wrap;">
            <a-button
              @click="students.splice(index, 1)"
              v-for="(item, index) in students"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;margin-bottom: 10px"
              >{{ item.name }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button
              style="margin-bottom: 10px"
              shape="round"
              size="small"
              @click="showAddStudents = true"
              ><a-icon type="plus" />选择添加孩子</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">关联领域</div>
        <div class="content">
          <a-space>
            <a-button
              @click="range.splice(index, 1)"
              v-for="(item, index) in range"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showRange = true"
              ><a-icon type="plus" />添加/选择关联领域</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">发展阶段</div>
        <bea-list
          :list="beas"
          @del="handleDelBea"
          @edit="handleEditbeva(item)"
          labelPos="block"
          backgroundColor="#fff"
        ></bea-list>
        <div
          class="content"
          :style="{ marginTop: beas.length ? '0px' : '20px' }"
        >
          <a-space>
            <a-button
              @click="form.level.splice(index, 1)"
              v-for="(item, index) in form.level"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="handleAddbeva"
              ><a-icon type="plus" />添加行为表现</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">记录时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            @change="onChangeDate"
            v-model="form.record_time"
          />
        </div>
      </section>

      <section class="section" style="border-bottom: none;">
        <div class="z-title">同步给家长 <span>*</span></div>
        <div class="content">
          <a-radio-group v-model="form.sync_parent">
            <a-radio :value="0">
              不同步
            </a-radio>
            <a-radio :value="1">
              同步
            </a-radio>
          </a-radio-group>
        </div>
      </section>

      <a-modal
        width="720px"
        :visible="showRange"
        @cancel="showRange = false"
        @ok="handleAddRange"
        title="选择领域"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in rangeList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group v-model="rangeCheckedList[index]">
            <a-row>
              <a-col
                v-for="(range, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox :value="range.name">
                  {{ range.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>

      

      <a-drawer
        :visible="showPlate"
        :title="false"
        placement="right"
        width="600px"
        :closable="false"
        :get-container="false"
        @close="showPlate = false"
        :bodyStyle="{ padding: 0 }"
      >
        <div class="drawer-content">
          <div class="head flex-row">
            <a-icon
              @click="showPlate = false"
              style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
              type="close"
            />
            <div class="title">
              选择记录模板
            </div>
            <a-space class="right">
              <a-button
                size="small"
                @click="handleChangePlate"
                shape="round"
                type="primary"
                >确定</a-button
              >
            </a-space>
          </div>
          <div class="body">
            <div class="title2">官方模板</div>
            <a-space class="plate">
              <div @click="selectType = 1" class="item">
                <div class="name">默认快速记</div>
                <a-radio-group v-model="selectType">
                  <a-radio
                    style="position: absolute;bottom: 5px;right: 1px;"
                    :value="1"
                  ></a-radio>
                </a-radio-group>
              </div>
              <div @click="selectType = 2" class="item">
                <div class="name">通用观察记录表</div>
                <a-radio-group v-model="selectType">
                  <a-radio
                    style="position: absolute;bottom: 5px;right: 1px;"
                    :value="2"
                  ></a-radio>
                </a-radio-group>
              </div>
            </a-space>
          </div>
        </div>
      </a-drawer>
    </div>
    <a-modal
        width="1300px"
        :visible="showDrag"
        @cancel="showDrag = false"
        @ok="handleAddRange"
        title="AI分析助手"
        :footer="null"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <ai-record :analysisImages="aiData.images" :analysisAudioUrl="aiData.audio" :text="aiData.white_text" :analysisVideoUrl="aiData.video" :studentId="students.length > 0 ? students[0].id : ''" :studentName="students.length > 0 ? students[0].name : ''" @copy-output="handleCopyOutput"></ai-record>
      </a-modal>
    <div v-if="form.type == 2" :key="active" class="srcoll">
      <div class="head flex-row">
        <div class="title">{{ id ? "编辑" : "发布" }}观察记录-观察记录表</div>
        <div v-if="!id" @click="handleShowPlate" class="right">
          <a-button type="link" size="small">
            <a-icon type="book" />更换记录表模板</a-button
          >
        </div>
      </div>

      <section class="section">
        <div class="z-title">记录时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            @change="onChangeDate"
            v-model="form.record_time"
          />
        </div>
      </section>

      <section class="section">
        <div class="z-title">记录老师 <span>*</span></div>
        <div class="content">
          {{ userInfo && userInfo.teacher_name }}
        </div>
      </section>

      <section class="section">
        <div class="z-title">观察对象 <span>*</span></div>
        <div class="content">
          <a-space style="width: 100%;flex-wrap: wrap;">
            <a-button
              @click="students.splice(index, 1)"
              v-for="(item, index) in students"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;margin-bottom: 10px"
              >{{ item.name }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button
              style="margin-bottom: 10px"
              shape="round"
              size="small"
              @click="showAddStudents = true"
              ><a-icon type="plus" />选择添加孩子</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">观察场景</div>
        <div class="content">
          <a-space>
            <a-button
              @click="cj.splice(index, 1)"
              v-for="(item, index) in cj"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button
              @click="selef_scene_ids.splice(index, 1)"
              v-for="(item, index) in selef_scene_ids"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showAddCj = true"
              ><a-icon type="plus" />选择添加观察场景</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <section
          v-for="(item, index) in record_att"
          :key="index"
          class="z-item"
          style="margin-bottom: 10px;"
        >
          <div class="z-title">
            观察实录<span>*</span
            ><a-button
              style="margin-left: 10px;font-size: 12px;"
              @click="record_att.splice(index, 1)"
              v-show="index != 0"
              size="small"
              ><a-icon
                style="margin-right: -5px;"
                type="delete"
              />移除</a-button
            >
          </div>
          <div class="input">
            <a-textarea
              placeholder="填写记录"
              autoSize
              v-model="item.record_text"
              :rows="4"
              :maxLength="3000"
              style="border: none;min-height: 100px"
            />
            <div class="number">{{ item.record_text.length }}/3000</div>
          </div>

          <div class="upload">
            <a-upload
              :style="{ width: item.fileList.length ? '100%' : '120px' }"
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="true"
              @preview="handlePreview"
              :remove="handleRemove"
              :before-upload="beforeUpload"
              :fileList="item.fileList"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
              multiple
              @change="
                (info) => {
                  item.fileList = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('@/assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传照片/视频
                </div>
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              :style="{ width: item.fileList2.length ? '100%' : '120px' }"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="true"
              :remove="handleRemove"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="audio/*"
              multiple
              :fileList="item.fileList2"
              @preview="handlePreview"
              @change="
                (info) => {
                  item.fileList2 = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('@/assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传音频
                </div>
              </div>
            </a-upload>
          </div>
          <div class="upload-tip">
            单个图片/视频不能超过500M;上传上限100张图片
          </div>
        </section>

        <a-button
          @click="handleAddObserve"
          style="margin-top: 5px"
          size="small"
          shape="round"
        >
          + 新增观察实录</a-button
        >
      </section>

      <section class="section">
        <div class="z-title">关联活动</div>
        <div class="content">
          <a-space>
            <a-button
              @click="activity.splice(index, 1)"
              v-for="(item, index) in activity"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>

            <a-button
              @click="selef_act_ids.splice(index, 1)"
              v-for="(item, index) in selef_act_ids"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showActivity = true"
              ><a-icon type="plus" />添加/选择关联活动</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">关联领域</div>
        <div class="content">
          <a-space>
            <a-button
              @click="range.splice(index, 1)"
              v-for="(item, index) in range"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showRange = true"
              ><a-icon type="plus" />添加/选择关联领域</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">发展阶段</div>
        <div v-if="beas.length" class="bea">
          <div class="bea-list">
            <bea-list
              :list="beas"
              @del="handleDelBea"
              @edit="handleEditbeva(item)"
              labelPos="block"
              backgroundColor="#fff"
            ></bea-list>
          </div>
        </div>
        <div
          class="content"
          :style="{ marginTop: beas.length ? '0px' : '20px' }"
        >
          <a-space>
            <a-button
              @click="form.level.splice(index, 1)"
              v-for="(item, index) in form.level"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="handleAddbeva"
              ><a-icon type="plus" />添加行为表现</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">观察分析</div>
        <div class="input">
          <a-textarea
            placeholder="填写观察分析"
            v-model="form.analysis"
            :rows="4"
            autoSize
            :maxLength="3000"
            style="border: none;min-height: 100px"
          />
          <div class="number">{{ form.analysis.length }}/3000</div>
        </div>

        <div class="upload">
          <a-upload
            :style="{ width: analysis_att1.length ? '100%' : '120px' }"
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            @preview="handlePreview"
            :fileList="analysis_att1"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'analysis_att1')"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
            multiple
          >
            <div>
              <a-icon type="plus" />
              <div class="ant-upload-text">
                点击上传照片/视频
              </div>
            </div>
          </a-upload>
          <a-upload
            name="avatar"
            :style="{ width: analysis_att2.length ? '100%' : '120px' }"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            @preview="handlePreview"
            :remove="handleRemove"
            :fileList="analysis_att2"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'analysis_att2')"
            accept="audio/*"
            multiple
          >
            <div>
              <a-icon type="plus" />
              <div class="ant-upload-text">
                点击上传音频
              </div>
            </div>
          </a-upload>
        </div>
        <div class="upload-tip">
          单个图片/视频不能超过500M;上传上限100张图片
        </div>
      </section>

      <section class="section">
        <div class="z-title">回应策略</div>
        <div class="input">
          <a-textarea
            placeholder="填写回应策略"
            v-model="form.strategy"
            autoSize
            :rows="4"
            :maxLength="3000"
            style="border: none;min-height: 100px;"
          />
          <div class="number">{{ form.strategy.length }}/3000</div>
        </div>

        <div class="upload">
          <a-upload
            :style="{ width: strategy_att1.length ? '100%' : '120px' }"
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :remove="handleRemove"
            :show-upload-list="true"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            :fileList="strategy_att1"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'strategy_att1')"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
            multiple
          >
            <div>
              <a-icon
                :type="uploadLoading.reback_cl_att1 ? 'loading' : 'plus'"
              />
              <div class="ant-upload-text">
                点击上传照片/视频
              </div>
            </div>
          </a-upload>
          <a-upload
            name="avatar"
            style="width: auto;"
            :style="{ width: strategy_att2.length ? '100%' : '120px' }"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            @preview="handlePreview"
            :fileList="strategy_att2"
            :remove="handleRemove"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'strategy_att2')"
            accept="audio/*"
            multiple
          >
            <div>
              <a-icon
                :type="uploadLoading.reback_cl_att2 ? 'loading' : 'plus'"
              />
              <div class="ant-upload-text">
                点击上传音频
              </div>
            </div>
          </a-upload>
        </div>
        <div class="upload-tip">
          单个图片/视频不能超过500M;上传上限100张图片
        </div>

        <div @click="showPush = 'cl'" class="selectCl">
          有20+回应策略可供参考
        </div>
      </section>

      <section class="section">
        <div class="z-title">家庭指导</div>
        <div class="input">
          <a-textarea
            placeholder="填写家庭指导"
            v-model="form.guidance"
            :rows="4"
            autoSize
            :maxLength="3000"
            style="border: none;min-height: 100px"
          />
          <div class="number">{{ form.guidance.length }}/3000</div>
        </div>

        <div class="upload">
          <a-upload
            :style="{ width: guidance_att1.length ? '100%' : '120px' }"
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :remove="handleRemove"
            @preview="handlePreview"
            :fileList="guidance_att1"
            :before-upload="beforeUpload"
            :show-upload-list="true"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'guidance_att1')"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
            multiple
          >
            <div>
              <a-icon
                :type="uploadLoading.guidance_att1 ? 'loading' : 'plus'"
              />
              <div class="ant-upload-text">
                点击上传照片/视频
              </div>
            </div>
          </a-upload>
          <a-upload
            name="avatar"
            style="width: auto;"
            :style="{ width: guidance_att2.length ? '100%' : '120px' }"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            :remove="handleRemove"
            :fileList="guidance_att2"
            @preview="handlePreview"
            :action="directorTestApi.main + directorTestApi.upload"
            @change="handleUploadChange($event, 'guidance_att2')"
            accept="audio/*"
            multiple
          >
            <div>
              <a-icon
                :type="uploadLoading.guidance_att2 ? 'loading' : 'plus'"
              />
              <div class="ant-upload-text">
                点击上传音频
              </div>
            </div>
          </a-upload>
        </div>
        <div class="upload-tip">
          单个图片/视频不能超过500M;上传上限100张图片
        </div>
        <div @click="showPush = 'guide'" class="selectCl">
          有20+家庭指导可供参考
        </div>
      </section>

      <section class="section" style="border-bottom: none;">
        <div class="z-title">同步给家长</div>
        <div class="content">
          <a-radio-group v-model="form.sync_parent">
            <a-radio :value="0">
              不同步
            </a-radio>
            <a-radio :value="1">
              同步
            </a-radio>
          </a-radio-group>
        </div>
      </section>
    </div>
    <a-modal
      :visible="showAddCj"
      width="780px"
      @cancel="showAddCj = false"
      :bodyStyle="{ padding: '10px 20px' }"
      @ok="handleAddCj"
      title="选择对应观察场景"
      centered
    >
      <div v-for="(item, index) in cjList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="cjCheckedList[index]">
          <a-row>
            <a-col
              v-for="(child, index2) in item.scenes"
              :key="index2"
              :span="8"
            >
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="range">
        <div class="Up">其他</div>
        <a-checkbox-group v-model="selef_scene_ids">
          <a-row>
            <a-col v-for="child in selef_scenes" :key="child.id" :span="8">
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
              <a-icon
                @click="handleDelSelef('scene', child.id)"
                style="margin-left: 10px;color: #999;font-size: 13px;flex: 1;cursor: pointer;"
                type="delete"
              ></a-icon>
            </a-col>
            <a-col :span="8">
              <a-button
                type="default"
                size="small"
                shap="round"
                ghost
                style="color: #999;margin-top: 2px"
                @click="handleAddSelef('scene')"
                >+自定义</a-button
              >
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <a-modal
      :visible="showSelef"
      @ok="handleAddSelefOk"
      title="添加自定义"
      width="480px"
      :z-index="3999"
      @cancel="showSelef = false"
      :bodyStyle="{ padding: '30px 20px' }"
      centered
    >
      <div>
        <a-input v-model="selef_name" placeholder="请输入自定义名称"></a-input>
      </div>
    </a-modal>

    <a-modal
      :visible="showActivity"
      @cancel="showActivity = false"
      @ok="handleAddActivity"
      title="选择关联活动"
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
      centered
    >
      <div v-for="(item, index) in activityList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="activityCheckedList[index]">
          <a-row>
            <a-col v-for="(act, index2) in item.acts" :key="index2" :span="6">
              <a-checkbox :value="act.name">
                {{ act.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="range">
        <div class="Up">其他</div>
        <a-checkbox-group v-model="selef_act_ids">
          <a-row>
            <a-col v-for="child in selef_acts" :key="child.id" :span="6">
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
              <a-icon
                @click="handleDelSelef('act', child.id)"
                style="margin-left: 10px;color: #999;font-size: 13px;flex: 1;cursor: pointer;"
                type="delete"
              ></a-icon>
            </a-col>
            <a-col :span="6">
              <a-button
                type="default"
                size="small"
                shap="round"
                ghost
                style="color: #999;margin-top: 2px"
                @click="handleAddSelef('act')"
                >+自定义</a-button
              >
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <a-modal
      :visible="showRange"
      @cancel="showRange = false"
      @ok="handleAddRange"
      title="选择领域"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="rangeCheckedList[index]">
          <a-row>
            <a-col
              v-for="(range, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-checkbox :value="range.name">
                {{ range.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <!--切换模板-->
    <a-drawer
      :visible="showPlate"
      :title="false"
      placement="right"
      width="600px"
      :closable="false"
      :get-container="false"
      @close="showPlate = false"
      :bodyStyle="{ padding: 0 }"
    >
      <div class="drawer-content">
        <div class="head flex-row">
          <a-icon
            @click="showPlate = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title">
            选择记录模板
          </div>
          <a-space class="right">
            <a-button size="small" @click="handleChangePlate" type="primary"
              >确定</a-button
            >
          </a-space>
        </div>
        <div class="body">
          <div class="title2">官方模板</div>
          <a-space class="plate">
            <div @click="selectType = 1" class="item">
              <div class="name">默认快速记</div>
              <a-radio-group v-model="selectType">
                <a-radio
                  style="position: absolute;bottom: 5px;right: 1px;"
                  :value="1"
                ></a-radio>
              </a-radio-group>
            </div>
            <div @click="selectType = 2" class="item">
              <div class="name">通用观察记录表</div>
              <a-radio-group v-model="selectType">
                <a-radio
                  style="position: absolute;bottom: 5px;right: 1px;"
                  :value="2"
                ></a-radio>
              </a-radio-group>
            </div>
          </a-space>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      :visible="showPush != ''"
      :title="false"
      placement="right"
      width="760px"
      :closable="false"
      :get-container="false"
      @close="showPush = false"
      :bodyStyle="{ padding: 0 }"
    >
      <div class="drawer-select">
        <div class="head flex-row">
          <a-icon
            @click="showPush = ''"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title">
            {{ showPush == "cl" ? "回应策略" : "家庭指导" }}
          </div>
          <a-space class="right">
            <a-button
              size="small"
              @click="handleConfrimCl"
              shape="round"
              :disabled="showPush == 'cl' ? selectNum == 0 : selectNum2 == 0"
              type="primary"
              >已选{{
                showPush == "cl" ? selectNum : selectNum2
              }}个,完成</a-button
            >
          </a-space>
        </div>
        <div class="body">
          <div class="flex-row head">
            <div class="num">
              共90条{{ showPush == "cl" ? "回应策略" : "家庭指导" }}
            </div>
            <a-dropdown>
              <a-button type="primary" size="small" shape="round">
                {{ currentPageClass.name }}
                <a-icon type="swap"></a-icon>
              </a-button>
              <a-menu slot="overlay">
                <a-menu-item
                  @click="handleChangeClass(item)"
                  v-for="(item, index) in gradeList"
                  :key="index"
                >
                  {{ item.name }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>

          <div class="hr"></div>

          <div v-if="showPush == 'cl'" class="cl-list">
            <div
              v-for="(clItem, index0) in clList"
              :key="index0"
              class="title-item"
            >
              <div class="title">{{ clItem.name }}</div>
              <a-collapse expand-icon-position="right" :bordered="false">
                <a-collapse-panel
                  v-for="(cl, index) in clItem.childs"
                  :key="index"
                  :header="cl.name"
                  :style="customStyle"
                >
                  <div class="cl-card">
                    <div
                      v-for="(item, index2) in cl.childs"
                      :key="index2"
                      class="item"
                    >
                      <div class="top">
                        <a-tag size="small" color="#67d5bd">
                          策略{{ index2 + 1 }}
                        </a-tag>
                        {{ item.name }}
                      </div>
                      <div class="foot">
                        <div class="select" style="font-weight: normal">
                          已选
                          {{ item.detail_id ? item.detail_id.length : 0 }} /
                          {{ cl.childs.length }}条策略
                        </div>
                        <a-button
                          size="small"
                          @click="handleSelectCl(item, cl)"
                          shape="round"
                          >+选择</a-button
                        >
                      </div>
                    </div>
                    <a-empty v-if="cl.childs.length == 0"></a-empty>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>

          <div v-if="showPush == 'guide'" class="cl-list">
            <div
              v-for="(guideItem, index) in guideList"
              :key="index"
              class="title-item"
            >
              <div class="title">{{ guideItem.name }}</div>
              <a-collapse expand-icon-position="right" :bordered="false">
                <a-collapse-panel
                  v-for="(guide, index2) in guideItem.childs"
                  :key="index2"
                  :header="guide.name"
                  :style="customStyle"
                >
                  <div class="cl-card">
                    <div
                      v-if="guide.childs.length"
                      v-for="(item, index3) in guide.childs"
                      :key="index3"
                      class="item"
                    >
                      <a-row
                        style="padding: 10px 0 0 0;border-bottom: 1px solid #eee"
                        :key="index2"
                      >
                        <a-checkbox
                          shape="circle"
                          :value="item.id"
                          :checked="item.checked"
                          @change="handleChangeGuide(item)"
                        >
                          <div
                            class="wrapper2"
                            style="padding-left: 30px;margin-top: -22px;width: 700px;font-weight: 400;"
                          >
                            {{ item.name }}
                          </div>
                        </a-checkbox>
                      </a-row>
                    </div>
                    <a-empty v-if="guide.childs.length == 0"></a-empty>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      :visible="showClDetail"
      :title="false"
      placement="right"
      width="500px"
      :closable="false"
      :get-container="false"
      @close="showClDetail = false"
      :bodyStyle="{ padding: 0 }"
    >
      <div v-if="activeCl" class="drawer-select">
        <div class="head flex-row">
          <a-icon
            @click="showClDetail = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title">
            {{ showPush == "cl" ? "回应策略" : "家庭指导" }}
          </div>
          <a-space class="right">
            <a-button
              size="small"
              @click="handleSelectCjDetail"
              shape="round"
              type="primary"
              >确定</a-button
            >
          </a-space>
        </div>
        <div class="body clDetail">
          <div class="cl-title">
            {{ activeCl.name }}
          </div>

          <a-checkbox-group class="cl-list" v-model="activeCl.detail_id">
            <a-row
              v-for="(item, index) in activeCl.childs"
              style="padding: 10px 0 0 0;border-bottom: 1px solid #eee"
              :key="index"
            >
              <a-checkbox shape="circle" :value="item.id">
                <div
                  class="wrapper2"
                  style="padding-left: 30px;margin-top: -22px;width: 465px;"
                >
                  <div class="name">{{ item.name }}</div>
                  <div class="content">{{ item.content }}</div>
                  <div class="source" style="margin-top: 6px;">
                    {{ item.source }}
                  </div>
                </div>
              </a-checkbox>
            </a-row>
          </a-checkbox-group>
        </div>
      </div>
    </a-drawer>
    <a-modal
      width="720px"
      :visible="showAddStudents"
      @cancel="showAddStudents = false"
      @ok="handleAddStudents"
      title="选择孩子"
      :bodyStyle="{ padding: '10px 20px' }"
      centered
    >
      <a-row>
        <a-checkbox :checked="checkAll" @change="handleSelectAllStudents">
          全部
        </a-checkbox>
      </a-row>
      <div v-for="(item, index) in studentList" :key="index" class="range">
        <div class="Up">{{ item.group_name }}</div>
        <!-- <a-checkbox-group @change="handleCancelAllStudents"> -->
        <a-row>
          <a-col
            v-for="(child, index2) in item.student"
            :key="index2"
            :span="6"
          >
            <a-checkbox
              @change="handleChangeSelectChild(child)"
              :checked="child.checked"
              :value="child.id"
            >
              {{ child.name }}
            </a-checkbox>
          </a-col>
        </a-row>
        <!-- </a-checkbox-group> -->
      </div>
    </a-modal>

    <a-modal
      :visible="showBea"
      @cancel="showBea = false"
      @ok="handleAddBea"
      title="选择表现行为"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-radio-group
          v-model="bea"
          name="bea"
          @change="handleChangeBea($event, item)"
          style="width: 100%;"
        >
          <a-row style="position: relative;">
            <a-col
              v-for="(child, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-radio
                :class="bea == child.name ? 'select-this' : ''"
                :value="child.name"
              >
                {{ child.name }}
              </a-radio>

              <div
                class="select"
                v-if="bea == child.name"
                style="width: 680px;overflow: hidden;padding: 5px 0;padding-top: 6px;border-top: 1px solid #6fb0dc;font-size: 12px;margin-top: 14px"
                :style="{ marginLeft: -(index2 / 4) * 680 + 'px' }"
              >
                <a-radio-group
                  @change="handleSelectBea2($event, child)"
                  style="width: 680px;"
                  name="bea2"
                >
                  <a-row>
                    <a-radio
                      v-for="(child2, index3) in child.childs"
                      :key="index3"
                      name="bea2"
                      style="font-size: 12px;color: #67b0dc"
                      @change="handleSelectBea3($event, child2)"
                      :value="child2.name"
                    >
                      {{ child2.name }}
                    </a-radio>
                  </a-row>
                </a-radio-group>
              </div>
            </a-col>
          </a-row>
        </a-radio-group>
      </div>
    </a-modal>
    <a-modal
      :visible="previewModal"
      @cancel="previewModal = false"
      centered
      title="预览"
      :footer="false"
      :closeable="false"
      :bodyStyle="{ padding: '20px 20px' }"
    >
      <div class="preview-body">
        <img
          style="width: 100%;height: auto"
          v-if="previewUrl.type == 'pic'"
          :src="previewUrl.url"
        />
        <video
          v-if="previewUrl.type == 'video'"
          style="width: 100%;height: 300px;object-fit: fill;"
          :src="previewUrl.url"
          controls
        ></video>
        <audio
          style="width: 100%;object-fit: fill;"
          v-if="previewUrl.type == 'record'"
          :src="previewUrl.url"
          controls
        ></audio>
      </div>
    </a-modal>

    <add-level
      :show="openBea"
      @add="handleConfirmAddBea"
      :data="selectBeaForm"
      @close="openBea = false"
    ></add-level>
  </div>
</template>

<script>
import axios from "axios";
import beaList from "../../components/bea-list-add.vue";
import { mapActions } from "vuex";
import qs from "qs";
import { checkFileFormat } from "@/utils/validate";
import _ from "lodash";
import addLevel from "./add-level.vue";
import { directorTestApi } from "../../api/api-director";
import { mapState } from "vuex";
import drag from "../../components/drag.vue";
import moment from "moment";

import aiRecord from "@/pages/ai/aiRecord.vue";

export default {
  data() {
    return {
      saveTime: "",
      data: null,
      selef_act_ids: [],
      selef_scene_ids: [],
      selef_scenes: [],
      selef_acts: [],
      previewUrl: "",
      previewModal: false,
      directorTestApi,
      bea: "",
      editState:false,
      showDrag: false,
      showBea: false,
      checkAll: false,
      showPlate: false,
      showPush: "",
      analysis_att1: [],
      analysis_att2: [],
      guidance_att1: [],
      guidance_att2: [],
      strategy_att1: [],
      selectBeaForm: null,
      cj: [],
      strategy_att2: [],
      record_att: [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ],
      form: {
        type: 2,
        content: "",
        record_time: null,
        strategy: "",
        act_id: "",
        record_att: [
          {
            record_text: "",
            fileList: [],
            fileList2: [],
          },
        ],
        analysis: "",
        guidance: "",
        range: [],
        status: 1,
        sync_parent: 0,
      },
      students: [],
      selectType: 2,
      loading: false,
      fileList: [],
      fileList2: [],
      showAddStudents: false,
      showAddCj: false,
      activeCl: null,
      studentList: [],
      checkedList: [],
      showRange: false,
      rangeCheckedList: [],
      active: 0,
      rangeList: [],
      range: [],
      activity: [],
      activityList: [
      ],
      showActivity: false,
      activityCheckedList: [],
      cjCheckedList: [],
      cjList: [
        {
          label: "生活",
          childs: [
            "来离园活动",
            "餐点活动",
            "饮水活动",
            "如厕盥洗活动",
            "午睡",
            "户外散步",
          ],
        },
        {
          label: "游戏",
          childs: ["角色游戏", "表演游戏", "结构游戏", "自由活动"],
        },
        {
          label: "学习",
          childs: [
            "集体教学",
            "益智区",
            "生活区",
            "语言区",
            "科学探索",
            "美工区",
            "音乐区",
          ],
        },
      ],
      SelectBea: null,
      customStyle:
        "background: #fff;border-radius: 4px;border: 0;overflow: hidden;font-weight:bold",
      activeKey: 0,
      showClDetail: false,
      clList: [],
      guideList: [],
      uploadLoading: {
        guidance_att1: false,
        guidance_att2: false,
        analysis_att1: false,
        analysis_att2: false,
        observe_att1: false,
        observe_att2: false,
        reback_cl_att1: false,
        reback_cl_att2: false,
      },
      openBea: false,
      beaSelect: null,
      beas: [],
      targets: [],
      showSelef: false,
      selefType: "scene",
      selef_name: "",
      id: "",
      gradeList: [],
      currentPageClass: {
        name: "",
      },
      selectNum2: 0,
      aiData:{
        images:[],
        audio:"",
        video:"",
      }
    };
  },

  components: {
    beaList,
    addLevel,
    drag,
    aiRecord,
  },
  computed: {
    ...mapState(["currentClass", "userInfo"]),
    selectNum() {
      let num = 0;
      if (this.showPush == "cl") {
        this.clList.forEach((child) => {
          child.childs.forEach((item) => {
            item.childs.forEach((detail) => {
              if (detail.detail_id) {
                num += detail.detail_id.length;
              }
            });
          });
        });
      }
      return num;
    },
    formContent() {
      if (
        this.form.record_time ||
        this.form.analysis ||
        this.form.student_id ||
        this.beas.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    showAddStudents(val) {
      if (val) {
        const students = this.students.map((item) => {
          return item.id;
        });
        this.studentList.forEach((group, index) => {
          group.student.forEach((item) => {
            if (students.includes(item.id)) {
              item.checked = true;
            }
          });
        });
      }
    },
    showRange(val) {
      if (val) {
        if (this.rangeList.length) {
          this.rangeList.forEach((group, index) => {
            this.rangeCheckedList[index] = [];
            group.childs.forEach((item) => {
              if (this.range.includes(item.name)) {
                this.rangeCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("领域加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.rangeList.forEach((group, index) => {
              this.rangeCheckedList[index] = [];
              group.childs.forEach((item) => {
                if (this.range.includes(item.name)) {
                  this.rangeCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    showActivity(val) {
      if (val) {
        if (this.activityList.length) {
          this.activityList.forEach((group, index) => {
            this.activityCheckedList[index] = [];
            group.acts.forEach((item) => {
              if (this.activity.includes(item.name)) {
                this.activityCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("活动加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.activityList.forEach((group, index) => {
              this.activityCheckedList[index] = [];
              group.acts.forEach((item) => {
                if (this.activity.includes(item.name)) {
                  this.activityCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    showAddCj(val) {
      if (val) {
        if (this.cjList.length) {
          this.cjList.forEach((group, index) => {
            this.cjCheckedList[index] = [];
            group.scenes.forEach((item) => {
              if (this.cj.includes(item.name)) {
                this.cjCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("场景加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.cjList.forEach((group, index) => {
              this.cjCheckedList[index] = [];
              group.childs.forEach((item) => {
                if (this.cj.includes(item.name)) {
                  this.cjCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    userInfo() {
      if (this.userInfo) {
        if (this.currentClass) {
          this.getAllStudents();
        } else {
          this.getClassList();
        }
        this.init();

        if (this.$route.query.id) {
          this.getDetail(this.$route.query.id, this.$route.query.type);
        }
      }
    },
    // form() {
    //   if (
    //     this.$route.query.id &&
    //     this.cjList.length &&
    //     this.activityList.length &&
    //     this.rangeList.length
    //   ) {
    //     _.debounce(this.handlePush("draft"), 10000);
    //   }
    // },
    showPush(newV) {
      if (newV) {
        this.getRebackList();
        this.getGuideList();
      }
    },
  },
  beforeDestroy() {
    if (this.saveTimer) {
      clearInterval(this.saveTimer);
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.form.id = this.$route.query.id;
    if (this.form.id) {
      this.editState = true
    }
    this.getGradeList();
    if (!this.$route.query.id) {
      this.form.record_time = moment().format("YYYY-MM-DD HH:mm:ss");
    } else if (this.userInfo) {
      this.getDetail(this.$route.query.id, this.$route.query.type);
    }

    if (this.userInfo) {
      if (this.currentClass) {
        this.getAllStudents();
      } else {
        this.getClassList();
      }
      this.init();
    }

    this.saveTimer = setInterval(() => {
      if (this.students.length && !this.editState) {
        this.handlePush("draft");
      }
    }, 10000);
  },
  methods: {
    beforeUpload(file) {
      if (!checkFileFormat(file)) {
        this.$message.error("请上传图片格式的文件");
        return false;
      }
      return true;
    },
    handleChangeClass(item) {
      this.currentPageClass = item;
      if (this.showPush == "cl") {
        this.getRebackList();
      } else {
        this.getGuideList();
      }
    },
    getGradeList() {
      axios({
        url: directorTestApi.main + directorTestApi.getSchoolGradeList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        method: "post",
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.gradeList = res.data.data;
          this.currentPageClass = this.gradeList[0];
        }
      });
    },
    getDetail(id, type) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url:
          type == "record"
            ? directorTestApi.main + directorTestApi.getObserRecordDetail
            : directorTestApi.main + directorTestApi.getObserNotableDetail,
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          id,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "获取成功",
            key: "loading",
            duration: 0.5,
          });
          const data = res.data.data;
          this.data = res.data.data;
          this.saveTime = data.addTime;
          this.form = {
            id: data.id,
            type: type == "record" ? 2 : 1,
            record_time: moment(data.record_time).format("YYYY-MM-DD HH:mm:ss"),
            strategy: data.strategy,
            act_id: "",
            record_att: [
              {
                record_text: "",
                fileList: [],
                fileList2: [],
              },
            ],
            teacher_name: data.teacher_name,
            analysis: data.analysis,
            guidance: data.guidance,
            range: [],
            status: 1,
            sync_parent: data.sync_parent ? 1 : 0,
          };
          this.students = data.students;

          

          if (type!='record') {
              this.record_att = [
            {
              record_text: data.record_text,
              fileList: data.recordAtt
                .filter((item) => item.type != "record")
                .map((item, index) => {
                  item.response = { data: _.cloneDeep(item) };
                  item.thumbUrl =
                    item.type == "video"
                      ? require("@/assets/director/video.png")
                      : item.url;
                  item.status = "done";
                  item.uid = item.id;
                  item.name = "record" + index;
                  item.response.data.id = item.accessory_id;
                  return item;
                }),
              fileList2: data.recordAtt
                .filter((item) => item.type == "record")
                .map((item, index) => {
                  item.thumbUrl = require("@/assets/director/record.png");
                  item.status = "done";
                  item.response = { data: _.cloneDeep(item) };
                  item.uid = item.id;
                  item.name = "audio" + index;
                  item.response.data.id = item.accessory_id;
                  return item;
                }),
            },
          ];
          }

          if (type == "record") {
            this.record_att = data.recordTextDetail.map((att) => {
            return {
              record_text: att.record_text,
              fileList: att.recordAtt
                .filter((item) => item.type != "record")
                .map((item, index) => {
                  item.response = { data: _.cloneDeep(item) };
                  item.thumbUrl =
                    item.type == "video"
                      ? require("@/assets/director/video.png")
                      : item.url;
                  item.status = "done";
                  item.uid = item.id;
                  item.name = "record" + index;
                  item.response.data.id = item.accessory_id;
                  return item;
                }),

              fileList2: att.recordAtt
                .filter((item) => item.type == "record")
                .map((item, index) => {
                  item.thumbUrl = require("@/assets/director/record.png");
                  item.status = "done";
                  item.response = { data: _.cloneDeep(item) };
                  item.uid = item.id;
                  item.name = "audio" + index;
                  item.response.data.id = item.accessory_id;
                  return item;
                }),
            };
          });
            this.analysis_att1 = data.analysisAtt
              .filter((item) => item.type != "record")
              .map((item, index) => {
                item.thumbUrl =
                  item.type == "video"
                    ? require("../../assets/director/video.png")
                    : item.url;
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "record" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });
            this.analysis_att2 = data.analysisAtt
              .filter((item) => item.type == "record")
              .map((item, index) => {
                item.thumbUrl = require("../../assets/director/record.png");
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "audio" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });

            this.guidance_att1 = data.guidanceAtt
              .filter((item) => item.type != "record")
              .map((item, index) => {
                item.thumbUrl =
                  item.type == "video"
                    ? require("../../assets/director/video.png")
                    : item.url;
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "record" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });

            this.guidance_att2 = data.guidanceAtt
              .filter((item) => item.type == "record")
              .map((item, index) => {
                item.thumbUrl = require("../../assets/director/record.png");
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "audio" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });

            this.strategy_att1 = data.strategyAtt
              .filter((item) => item.type != "record")
              .map((item, index) => {
                item.thumbUrl =
                  item.type == "video"
                    ? require("../../assets/director/video.png")
                    : item.url;
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "record" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });

            this.strategy_att2 = data.strategyAtt
              .filter((item) => item.type == "record")
              .map((item, index) => {
                item.thumbUrl = require("../../assets/director/record.png");
                item.status = "done";
                item.response = { data: _.cloneDeep(item) };
                item.uid = item.id;
                item.name = "audio" + index;
                item.response.data.id = item.accessory_id;
                return item;
              });

            this.activity = data.obserAct.map((item) => item.name);
            this.cj = data.scenes.map((item) => item.name);
          }

          this.range = data.fields.map((item) => item.target_name);
          this.beas = data.target2;
          this.showModal = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRemove() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "提示",
          content: "确定要删除吗？",
          centered: true,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          },
        });
      });
    },
    handleDelSelef(type, id) {
      axios({
        url:
          type == "scene"
            ? directorTestApi.main + directorTestApi.saveDeleteObserSelfScene
            : directorTestApi.main + directorTestApi.saveDeleteObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "删除成功",
          });
          if (type == "scene") {
            this.getSelefScenes();
          } else {
            this.getSelefActs();
          }
        } else {
          this.$message.error({ content: res.data.message });
        }
      });
    },
    handleAddSelef(type) {
      this.selefType = type;
      this.showSelef = true;
    },
    handleAddSelefOk() {
      this.$message.loading({
        content: "正在添加...",
        key: "addSelef",
      });
      axios({
        url:
          this.selefType == "scene"
            ? directorTestApi.main + directorTestApi.saveObserSelfScene
            : directorTestApi.main + directorTestApi.saveObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          name: this.selef_name,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "添加成功",
            key: "addSelef",
          });
          this.selefType == "scene"
            ? this.getSelefScenes()
            : this.getSelefActs();
          this.showSelef = false;
          this.selef_name = "";
        } else {
          this.$message.error({ content: res.data.message, key: "addSelef" });
        }
      });
    },
    getSelefScenes() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfSceneList,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_scenes = res.data.data;
          this.selef_scene_ids = this.selef_scene_ids.filter((name) => {
            if (this.selef_scenes.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_scenes = [];
        }
      });
    },
    getSelefActs() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfActList,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_acts = res.data.data;
          this.selef_act_ids = this.selef_act_ids.filter((name) => {
            if (this.selef_acts.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_acts = [];
        }
      });
    },
    handleDelBea(index, index2) {
      console.log(index, index2);
      this.beas[index].targets.splice(index2, 1);
      this.$forceUpdate();
    },
    handleConfirmAddBea(list) {
      list.forEach((item) => {
        if (this.beas.map((item2) => item2.id).includes(item.id)) {
          this.beas.forEach((detail) => {
            if (detail.id == item.id) {
              //学生id重复
              item.targets.forEach((target1) => {
                if (
                  detail.targets.map((item3) => item3.id).includes(target1.id)
                ) {
                  // 一级二级重复
                  //根据id判断item.targets.targets和detail.targets.targets下面列表是否重复,重复只保留一个
                  target1.targets.forEach((target2) => {
                    const detail2 = detail.targets.find(
                      (item4) => item4.id == target1.id
                    );
                    const ids = detail2.targets.map((item3) => item3.id);
                    if (ids.includes(target2.id)) {
                    } else {
                      detail2.targets.push(target2);
                    }
                  });
                } else {
                  detail.targets.push(target1);
                }
              });
            }
          });
        } else {
          this.beas.push(item);
        }
      });
      console.log(this.beas);
      this.openBea = false;
    },
    handleChangeSelectChild(child) {
      child.checked = !child.checked;
      this.$forceUpdate();
    },
    handleChangeGuide(child) {
      child.checked = !child.checked;
      let num = 0;

      this.guideList.forEach((child) => {
        child.childs.forEach((item) => {
          item.childs.forEach((detail) => {
            if (detail.checked) {
              num++;
            }
          });
        });
      });

      this.selectNum2 = num;
      this.$forceUpdate();
    },
    onChangeDate(e, date) {
      console.log(e, date);
      this.form.record_time = date;
    },
    handlePreview(e) {
      console.log(e);
      this.previewUrl = {
        url: e.response.data.url,
        type: this.getFileType(e.response.data.url),
      };
      this.previewModal = true;
    },
    getFileType(url) {
      //根据资源路径后缀判断资源类型
      const type = url.split(".").pop();
      if (type == "mp4" || type == "avi" || type == "mov") {
        return "video";
      }

      if (type == "jpg" || type == "png" || type == "jpeg") {
        return "pic";
      }

      if (type == "mp3" || type == "wav" || type == "aac" || type == "ogg") {
        return "record";
      }
    },
    init() {
      this.getActList();
      this.getSceneList();
      this.getRangeList();
      this.getSelefActs();
      this.getSelefScenes();
    },
    getSceneList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserSceneList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.cjList = res.data.data;
      });
    },
    getRangeList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getFieldList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...form,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        this.rangeList = res.data.data;
      });
    },
    getRebackList() {
      if (!this.currentPageClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id || "",
        grade_id: this.currentPageClass.id,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRebackList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        // this.clList = res.data.data;

        this.clList = res.data.data.map((arr) => {
          let list = [];
          arr.childs.forEach((item) => {
            list = [...list, ...item.childs.flat()];
          });

          arr.childs = list;
          return arr;
        });
      });
    },
    getGuideList() {
      if (!this.currentPageClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id || "",
        grade_id: this.currentPageClass.id,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserGuideList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.guideList = res.data.data.map((arr) => {
          let list = [];
          arr.childs.forEach((item) => {
            list = [...list, ...item.childs.flat()];
          });

          arr.childs = list;
          return arr;
        });
        this.selectNum2 = 0;
        console.log(this.guideList);
      });
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        teacher_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.userInfo.school_id || "",
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        if (res.data.result) {
          this.classList = res.data.data;
          this.className = this.classList[0].class_name;
          this.$store.state.currentClass = this.classList[0];
          this.getAllStudents();
          this.getGuideList();
          this.getRebackList();
        } else {
          this.$message.error("未获取到班级信息");
          this.loading = false;
        }
      });
    },
    getAllStudents() {
      this.studentListForm = {
        class_id: this.currentClass.id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        teacher_id: this.userInfo.id,
        school_id: this.userInfo.school_id || "",
      };

      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getGroupStudentList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.studentList = [
          {
            label: "A",
            childs: res.data.data,
          },
        ];
        this.studentList = res.data.data;
      });
    },
    ...mapActions(["setBea"]),
    getObserRebackList() {
      axios({
        method: "get",
        url: directorTestApi.main + directorTestApi.getObserRebackList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
      });
    },
    handleShowDrag() {
      //如果没有选择学生，提示请至少选择一位学生
      if (this.students.length === 0) {
        this.$message.warning('请选择一位学生');
        return;
      }
      if (this.students.length > 1) {
        this.$message.warning('AI分析，只能对单个学生进行分析，请调整学生');
        return;
      }

      // 清空数据
      this.aiData = {
        images:[],
        audio:"",
        video:"",
      }
      //筛选数据，收集所有上传的图片地址数组，收集第一个视频地址，收集第一个音频地址
      
      // 收集所有图片
      const allFiles = [];
      
      // 处理record_att数组中的fileList和fileList2
      this.record_att.forEach(att => {
        if (att.fileList) {
          allFiles.push(...att.fileList);
        }
        if (att.fileList2) {
          allFiles.push(...att.fileList2);
        }
      });
      
      // 处理其他数组
      [this.analysis_att1, this.analysis_att2, this.guidance_att1, this.guidance_att2, this.strategy_att1, this.strategy_att2].forEach(attArray => {
        if (Array.isArray(attArray)) {
          allFiles.push(...attArray);
        }
      });
      
      // 检查reback_cl_att1和reback_cl_att2是否是文件列表数组
      if (Array.isArray(this.reback_cl_att1)) {
        allFiles.push(...this.reback_cl_att1);
      }
      if (Array.isArray(this.reback_cl_att2)) {
        allFiles.push(...this.reback_cl_att2);
      }
      
      console.log(allFiles,'allfiles');
      // 收集图片
      this.aiData.images = allFiles.filter(file => (file.type.indexOf('pic') > -1 || file.type.indexOf('image') > -1) && file.response.data.url).map(file => file.response.data.url);
      this.aiData.white_text = this.record_att[0].record_text || ""; //第一个文本
      // 收集第一个音频
      const firstAudio = allFiles.find(file => (file.type.indexOf('record') > -1 || file.type.indexOf('audio') > -1) && file.response.data.url);
      if (firstAudio) {
        this.aiData.audio = firstAudio.response.data.url;
      }
      console.log(this.aiData)
      // 收集第一个视频
      const firstVideo = allFiles.find(file => file.type.indexOf('video') > -1 && file.response.data.url);
      if (firstVideo) {
        this.aiData.video = firstVideo.response.data.url;
      }
      console.log(this.aiData);
      this.showDrag = true;
    },
    // 处理从AI分析助手传递过来的领域和行为表现数据
    handleCopyOutput(module9Data) {
      console.log('接收到的模块9数据:', module9Data);
      if (!module9Data || !module9Data.module1_result_table) {
        this.$message.warning('接收到的数据格式不正确');
        return;
      }
      
      // 处理range数据（关联领域）
      this.handleRangeData(module9Data.module1_result_table);
      
      // 处理beas数据（发展阶段/行为表现）
      this.handleBeasData(module9Data.module1_result_table);
      
      // 关闭AI分析助手弹窗
      this.showDrag = false;
    },
    // 处理关联领域数据
    handleRangeData(resultTable) {
      console.log(resultTable, "resultTable");
      // 从结果表格中提取所有领域名称（取目标字符串中->前面的部分）
      const domainNames = resultTable.map(item => {
        const targetParts = item.目标.split(' -> ');
        return targetParts[0] || '';
      }).filter((value, index, self) => self.indexOf(value) === index && value);
      
      // 更新range数组
      this.range = [...new Set([...this.range, ...domainNames])];
      
      // 更新rangeCheckedList（用于模态框中的勾选状态）
      if (this.rangeList.length > 0) {
        // 初始化rangeCheckedList为与rangeList结构匹配的二维数组
        this.rangeCheckedList = this.rangeList.map(group => []);
        
        // 遍历所有领域名称，找到对应的分组和子项
        domainNames.forEach(domainName => {
          this.rangeList.forEach((group, groupIndex) => {
            const matchedChild = group.childs.find(child => child.name === domainName);
            if (matchedChild) {
              // 如果找到匹配的子项，添加到对应的分组中
              this.rangeCheckedList[groupIndex].push(matchedChild.name);
            }
          });
        });
      }
      
      this.$message.success('关联领域已自动更新');
    },
    // 处理发展阶段/行为表现数据
    handleBeasData(resultTable) {
      // 转换智能体返回的数据格式为beas所需的格式
      const convertedBeas = [];
      
      // 按学生分组处理数据
      this.students.forEach(student => {
        // 创建学生的bea对象
        const studentBea = {
          class_name: student.class_name || undefined,
          id: student.id || '',
          name: student.name || '',
          sex: student.sex || '',
          targets: []
        };
        
        // 为每个学生添加目标数据
        resultTable.forEach(item => {
          // 解析目标字段，提取二级目标和三级目标
          const targetParts = item.目标.split(' -> ');
          let field2_name = '';
          let field3_name = '';
          
          if (targetParts.length === 2) {
            field2_name = targetParts[0];
            field3_name = targetParts[1];
          } else if (targetParts.length === 1) {
            field3_name = targetParts[0];
          }
          
          // 处理阶梯列表
          const steps = item.阶梯集合.map(step => ({
            name: step.阶梯 || '',
            id: step.阶梯id || ''
          }));
          
          // 添加目标数据
          studentBea.targets.push({
            field_name: item.领域 || '',
            field2_name: field2_name,
            field3_name: field3_name,
            id: item.领域id || '',
            targets: steps
          });
        });
        
        // 如果学生有目标数据，添加到convertedBeas数组
        if (studentBea.targets.length > 0) {
          convertedBeas.push(studentBea);
        }
      });
      
      // 如果没有学生数据，创建一个默认的学生对象
      if (convertedBeas.length === 0 && resultTable.length > 0) {
        const defaultBea = {
          class_name: undefined,
          id: '',
          name: '',
          sex: '',
          targets: []
        };
        
        resultTable.forEach(item => {
          // 解析目标字段，提取二级目标和三级目标
          const targetParts = item.目标.split(' -> ');
          let field2_name = '';
          let field3_name = '';
          
          if (targetParts.length === 2) {
            field2_name = targetParts[0];
            field3_name = targetParts[1];
          } else if (targetParts.length === 1) {
            field3_name = targetParts[0];
          }
          
          // 处理阶梯列表
          const steps = item.阶梯集合.map(step => ({
            name: step.阶梯 || '',
            id: step.阶梯id || ''
          }));
          
          defaultBea.targets.push({
            field_name: item.领域 || '',
            field2_name: field2_name,
            field3_name: field3_name,
            id: item.领域id || '',
            targets: steps
          });
        });
        
        convertedBeas.push(defaultBea);
      }
      
      // 更新beas数组
      this.beas = convertedBeas;
      this.$message.success('行为表现已自动更新');
    },
    getActList() {
      axios({
        method: "get",
        url: directorTestApi.main + directorTestApi.getObserActList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        params: {
          currentPage: 1,
          pageSize: 100,
          school_id: this.userInfo.school_id || "",
        },
      }).then((res) => {
        this.activityList = res.data.data;
      });
    },
    handleChangeBea(e, item) {
      this.selectBeaForm = {
        range: item.name,
      };
    },
    handleAddBea() {
      if (!this.selectBeaForm || !this.selectBeaForm.detail) {
        this.$message.error("请选择目标");
        return;
      }
      this.selectBeaForm.students = this.students;
      this.selectBeaForm.students.map((item) => {
        item.bea = _.cloneDeep(this.selectBeaForm.detail);
        return item;
      });
      this.openBea = true;
      this.showBea = false;
    },
    handleEditbeva(studentBea) {
      console.log(studentBea);
      this.selectBeaForm = {
        detail: studentBea.bea,
        students: [studentBea],
      };
    },
    handleSelectBea2(e, child) {
      this.selectBeaForm = {
        range: this.selectBeaForm.range.split(">")[0] + ">" + child.name,
        rangeId: this.selectBeaForm.rangeId || "",
        detail: child.childs.filter((item) => item.name == e.target.value)[0],
        students: this.students.map((item) => {
          item.bea = _.cloneDeep(
            child.childs.filter((item) => item.name == e.target.value)[0]
          );
        }),
      };
    },
    handleSelectBea3(e, child) {
      console.log(e);
      this.selectBeaForm.rangeId = child.id;
    },
    handleCancelAllStudents() {
      this.checkAll = false;
    },
    handleSelectAllStudents(e) {
      this.checkAll = e.target.checked;
      if (e.target.checked) {
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = true;
          });
        });
      } else {
        this.students = [];
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = false;
          });
        });
      }
      this.$forceUpdate();
    },
    //选择策略详情
    handleSelectCjDetail() {
      console.log(this.activeCl, this.clList);
      // if (this.activeCl.detail_id.length > 2) {
      //   this.$message.error("超出策略选择上限");
      //   return;
      // }
      this.showClDetail = false;
    },
    handleShowPlate() {
      if (this.formContent) {
        this.$confirm({
          title: "更换模板后，已经输入的内容不能同步保存哦",
          type: "warning",
          centered: true,
          size: "small",
          icon: "exclamation-circle",
          onOk: () => {
            this.showPlate = true;
          },
          onCancel: () => {},
        });
      } else {
        this.showPlate = true;
      }
    },
    handleAddObserve() {
      this.record_att.push({
        record_text: "",
        fileList: [],
        fileList2: [],
      });
    },
    handleAddbeva() {
      if (this.students.length < 1) {
        this.$message.error("请先选择观察对象");
        return;
      }
      this.showBea = true;
      // this.$router.push("/observe/addLevel");
    },
    handleChangePlate() {
      this.form.type = this.selectType;
      this.showPlate = false;
      this.checkedList = [];
      this.rangeCheckedList = [];
      this.cjCheckedList = [];
      this.form.id = "";
      this.beas = [];
      (this.record_att = [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ]),
        (this.analysis_att = []);
      this.guidance_att = [];
      this.students = [];
      this.form = {
        type: this.form.type,
        content: "",
        record_time: moment().format("YYYY-MM-DD HH:mm:ss"),
        strategy: "",
        act_id: "",
        record_att: [
          {
            record_text: "",
            fileList: [],
            fileList2: [],
          },
        ],
        analysis: "",
        guidance: "",
        range: [],
        status: 1,
        sync_parent: 0,
      };
      if (this.saveTimer) {
        clearInterval(this.saveTimer);
      }
      this.saveTimer = setInterval(() => {
        if (this.students.length) {
          this.handlePush("draft");
        }
      }, 10000);
    },
    handleSelectCl(item, cl) {
      this.activeCl = item;
      this.showClDetail = true;
    },
    onChange(e) {
      console.log(e);
      this.checkedList = e;
    },
    handleAddRange() {
      console.log(this.rangeCheckedList);
      this.range = this.rangeCheckedList.flat();
      this.showRange = false;
    },
    handleAddStudents() {
      this.students = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
      this.$store.state.beaStudents = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
      this.showAddStudents = false;
    },
    handleAddCj() {
      this.cj = this.cjCheckedList.flat();
      this.showAddCj = false;
      console.log(this.selef_scene_ids);
    },
    handleAddActivity() {
      this.activity = this.activityCheckedList.flat();
      this.showActivity = false;
    },
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    //策略家庭确认选择
    handleConfrimCl() {
      let content = "";
      if (this.showPush == "cl") {
        let mbIndex = 1;
        this.clList.forEach((child) => {
          child.childs.forEach((item) => {
            let detailStr = "";
            item.childs.forEach((detail) => {
              if (detail.detail_id) {
                detailStr +=
                  "第" +
                  this.SectionToChinese(mbIndex) +
                  " " +
                  detail.name +
                  "\n";
                mbIndex++;
                detail.childs.forEach((item) => {
                  const label = detail.detail_id.filter((id) => item.id == id);
                  if (label.length) {
                    detailStr += item.name + "\n";
                  }
                });
              }
            });
            content += detailStr;
          });
        });
        this.form.strategy = content;
      } else {
        let mbIndex = 1;
        this.guideList.forEach((child) => {
          child.childs.forEach((item) => {
            let detailStr = "";
            item.childs.forEach((detail, index) => {
              if (detail.checked) {
                if (index == 0) {
                  detailStr +=
                    "第" +
                    this.SectionToChinese(mbIndex) +
                    " " +
                    item.name +
                    "\n";
                  mbIndex++;
                }
                detailStr += detail.name + "\n";
              }
            });
            content += detailStr;
          });
        });
        this.form.guidance = content;
      }

      this.showPush = "";
    },
    handlePush(type) {
      if (this.pushing) {
        this.$message.error("正在保存中，请勿重复保存");
        return;
      }
      this.form.data_type = type;
      if (this.formContent || type == "draft") {
        this.pushing = true;
        this.form.student_id = this.students.map((item) => item.id).join(",");
        if (this.beas.length) {
          this.form.targets = JSON.stringify(
            this.beas.map((item) => {
              return {
                student_id: item.id,
                target_id: item.targets
                  .map((target1) => {
                    return target1.targets
                      .map((target2) => {
                        return target2.id;
                      })
                      .join(",");
                  })
                  .join(","),
              };
            })
          );
        }

        try {
          this.form.teacher_id = this.userInfo.id;
          this.school_id = this.userInfo.school_id || "";
          const act_names = this.activityCheckedList.flat();
          const act_ids = [];
          this.activityList.forEach((item) => {
            item.acts.forEach((act) => {
              if (act_names.includes(act.name)) {
                act_ids.push(act.id);
              }
            });
          });
          this.form.act_id = act_ids.join(",");

          const range_names = this.range.flat();
          const range_ids = [];
          this.rangeList.forEach((item) => {
            item.childs.forEach((range) => {
              if (range_names.includes(range.name)) {
                range_ids.push(range.id);
              }
            });
          });
          this.form.field_id = range_ids.join(",");

          const scene_names = this.cjCheckedList.flat();
          const scene_ids = [];
          this.cjList.forEach((item) => {
            item.scenes.forEach((sce) => {
              if (scene_names.includes(sce.name)) {
                scene_ids.push(sce.id);
              }
            });
          });
          this.form.scene_id = scene_ids.join(",");

          const analysis_list = [
            ...this.analysis_att1.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
            ...this.analysis_att2.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
          ];

          this.form.analysis_att = analysis_list.length
            ? JSON.stringify(analysis_list)
            : "";

          const guidance_list = [
            ...this.guidance_att1.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
            ...this.guidance_att2.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
          ];

          this.form.guidance_att = guidance_list.length
            ? JSON.stringify(guidance_list)
            : "";

          const strategy_list = [
            ...this.strategy_att1.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
            ...this.strategy_att2.map((item) => {
              return {
                accessory_id: item.response.data.id,
                content: "",
              };
            }),
          ];

          this.form.strategy_att = strategy_list.length
            ? JSON.stringify(strategy_list)
            : "";

          this.form.record_att = JSON.stringify(
            this.record_att.map((item) => {
              return {
                record_text: item.record_text,
                attVo:
                  item.fileList.length + item.fileList2.length
                    ? [
                        ...item.fileList.map((item) => {
                          return {
                            accessory_id: item.response.data.id,
                            content: "",
                          };
                        }),
                        ...item.fileList2.map((item) => {
                          return {
                            accessory_id: item.response.data.id,
                            content: "",
                          };
                        }),
                      ]
                    : "",
              };
            })
          );

          this.form.class_id = this.currentClass.id;
          // this.form.scene_id = this.cjCheckedList.
          if (this.form.type == 1) {
            if (type != "draft") {
              this.$message.loading({
                content: "数据提交中",
                duration: 3,
                key: "submit",
              });
            } else {
              this.saveTime = "正在保存...";
            }
            this.school_id = this.userInfo.school_id || "";
            this.form.record_text = this.record_att[0].record_text;
            (this.form.record_att =
              this.record_att[0].fileList.length +
              this.record_att[0].fileList2.length
                ? JSON.stringify([
                    ...this.record_att[0].fileList.map((item) => {
                      return {
                        accessory_id: item.response.data.id,
                        content: "",
                      };
                    }),
                    ...this.record_att[0].fileList2.map((item) => {
                      return {
                        accessory_id: item.response.data.id,
                        content: "",
                      };
                    }),
                  ])
                : ""),
              axios({
                method: "post",
                url: directorTestApi.main + directorTestApi.saveNotable,
                headers: {
                  "content-type": "application/x-www-form-urlencoded",
                  Authorization: this.$store.state.headers,
                },
                data: qs.stringify(this.form),
              }).then((res) => {
                this.pushing = false;
                if (res.data.code == 1) {
                  if (type != "draft") {
                    this.$message.success({
                      content: "提交成功",
                      key: "submit",
                    });
                  }

                  if (type != "draft") {
                    setTimeout(() => {
                      this.$router.back();
                    }, 800);
                  } else {
                    this.form.id = res.data.data;
                    setTimeout(() => {
                      this.saveTime =
                        "自动保存成功 " + moment().format("YYYY-MM-DD HH:mm");
                    }, 300);
                  }
                } else {
                  this.$message.error({
                    content: res.data.message,
                    key: "submit",
                  });
                  this.saveTime = "";
                }
              });
          } else if (this.form.type == 2) {
            this.school_id = this.userInfo.school_id || "";
            this.form.selef_scene_id = this.selef_scene_ids
              .map((name) => {
                return this.selef_scenes.filter((item) => item.name == name)[0]
                  .id;
              })
              .join(",");
            this.form.selef_act_id = this.selef_act_ids
              .map((name) => {
                return this.selef_acts.filter((item) => item.name == name)[0]
                  .id;
              })
              .join(",");

            if (type != "draft") {
              this.$message.loading({
                content: "数据提交中",
                duration: 3,
                key: "submit",
              });
            } else {
              this.saveTime = "正在保存...";
            }

            axios({
              method: "post",
              url: directorTestApi.main + directorTestApi.saveObserve,
              headers: {
                "content-type": "application/x-www-form-urlencoded",
                Authorization: this.$store.state.headers,
              },
              data: qs.stringify(this.form),
            }).then((res) => {
              this.pushing = false;
              if (res.data.code == 1) {
                if (type != "draft") {
                  this.$message.success({
                    content: "提交成功",
                    key: "submit",
                  });
                }

                if (type != "draft") {
                  setTimeout(() => {
                    this.$router.back();
                  }, 800);
                } else {
                  setTimeout(() => {
                    this.saveTime =
                      "自动保存成功 " + moment().format("YYYY-MM-DD HH:mm");
                  }, 300);
                  this.form.id = res.data.data;
                }
              } else {
                this.$message.error({
                  content: res.data.message,
                  key: "submit",
                });
                this.saveTime = "";
              }
            });
          }
        } catch (error) {
          this.pushing = false;
          if (type != "draft") {
            this.$message.error("文件正在上传，稍后再试");
          }
        }
      } else {
        this.$message.error("请完善必填内容");
      }
    },
    handleUploadChange(info, key) {
      console.log(info);
      this[key] = info.fileList.map((item) => {
        if (!item.thumbUrl && item.status == "done") {
          item.thumbUrl =
            item.type.indexOf("audio") > -1
              ? require("../../assets/director/record.png")
              : require("../../assets/director/video.png");
        }
        return item;
      });
      console.log(this[key]);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-checkbox-group {
  width: 100%;
}
section.section {
  border-bottom: 1px solid #ececec;
  padding: 20px 0;

  .z-title {
    position: relative;
    padding-left: 10px;
    line-height: 1.2;
    font-size: 14px;
    color: #555;
    font-weight: bold;
    &::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 3px;
      background: #73b5de;
      height: 100%;
    }
    span {
      color: red;
      margin-left: 1px;
    }
    span.tip {
      color: #999;
      font-weight: 400;
      margin-left: 5px;
    }
  }

  .input {
    margin-top: 10px;
    position: relative;
    .number {
      position: absolute;
      right: 12px;
      bottom: 3px;
      font-size: 12px;
      color: #7a7a7a;
    }
  }

  .upload {
    margin-top: 10px;
    span {
      display: inline-block;
    }
  }
  .upload-tip {
    font-size: 12px;
    color: #999;
    width: 100%;
  }

  .content {
    margin-top: 20px;
  }
}

.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
  }
}

.page {
  height: 100%;
  max-width: 900px;
  position: relative;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll {
    height: calc(100% - 75px);
    overflow-y: auto;
    padding: 15px 20px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}

.drawer-select {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    width: 100%;
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      user-select: none;
      .item {
        font-size: 12px;
        width: 120px;
        height: 155px;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        color: #555;
        position: relative;
        font-size: 14px;
        box-shadow: 2px 3px 6px 3px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}

.selectCl {
  border: 1px solid #92b8cf !important;
  color: #fff !important;
  background: #7da2b9 !important;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}

.bea {
  margin-top: 10px;
  .mb {
    color: #598ebe;
    font-weight: bold;
    margin: 5px 0;
  }
  .students {
    margin: 10px 0;
  }
  .bea-list {
    width: 100%;
    .cell {
      padding: 5px 10px;
      border-radius: 20px;
      border: 1px solid #eee;
      margin: 8px 0;
      box-shadow: 0 0 2px 1px rgba($color: #000000, $alpha: 0.06);
    }
  }
}

.hr {
  height: 6px;
  background: #eee;
}

.cl-card {
  width: 100%;
  box-shadow: 0 0 3px 2px rgba($color: #000000, $alpha: 0.08);
  padding: 10px;
  border-radius: 8px;
  .item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .foot {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    font-size: 12px;

    .select {
      color: #999;
      margin-right: auto;
    }
  }
}

.clDetail {
  width: 100%;
  padding: 15px;
  .cl-title {
    font-size: 14px;
    font-weight: bold;
  }

  .cl-list {
    margin: 10px 0;
    .title {
      font-size: 12px;
      color: #999;
      padding: 10px;
    }
  }
}

.cl-list {
  margin: 10px 0;
  .title {
    font-size: 14px;
    color: #8a8a8a;
    padding: 5px 15px 5px 25px;
    font-weight: bold;
    position: relative;
    &::after {
      position: absolute;
      left: 15px;
      top: 8px;
      width: 3px;
      bottom: 8px;
      content: "";
      background: #cdcdcd;
    }
  }
}

.select-this {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    //倒三角
    width: 0;
    z-index: 20;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #90bce6 transparent;
    left: 42%;
    top: 24px;
  }
}

.ant-checkbox-wrapper {
  .wrapper2 {
    height: auto;
    position: static;
    .name {
      font-size: 14px;
      color: #333;
    }
    .content {
      color: #666;
    }
    .source {
      text-align: right;
      color: #999;
    }
  }
}
</style>
